/*
 *  Copyright (C) 2019 schroeder.org - All Rights Reserved
 *  Unauthorized copying of this file or deriving works therefrom,
 *  via any medium, is strictly prohibited
 *  Proprietary and confidential
 *  <dev@schroeder.org>
 */

import Vue from 'vue';
import App from './App.vue';
import router from './router';

declare module 'vue/types/vue' {
  // noinspection JSUnusedGlobalSymbols
  interface VueConstructor {
    $log: any;
  }
}

// add console logger
Vue.$log = (arg1: any, arg2: any) => {
  if (process.env.NODE_ENV !== 'production') {
    // Vue wraps objects in observers, so unwrap those for easier debugging
    const expandObserver = (obj: any): any => {
      if (obj && typeof obj === 'object') {
        return JSON.parse(JSON.stringify(obj));
      }

      return obj;
    };

    if (arg2) {
      console.log(arg1, expandObserver(arg2)); // eslint-disable-line no-console
    } else {
      console.log(expandObserver(arg1)); // eslint-disable-line no-console
    }
  }
};
// noinspection JSUnusedGlobalSymbols
Vue.prototype.$log = Vue.$log;

// disable production tip
Vue.config.productionTip = false;

// noinspection JSUnusedGlobalSymbols
(window as any).App = new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
